<style scoped>
.v-application .subtitle-1 {
  font-size: 14px !important;
  font-weight: normal;
  letter-spacing: 0.009375em !important;
  line-height: 1.75rem;
  font-family: "Prompt", sans-serif !important;
}
</style>

<template>
  <div>
    <v-file-input
      dense
      multiple
      chips
      outlined
      accept="image/*,.pdf"
      @change="onSelect"
      prepend-inner-icon="mdi-plus"
      prepend-icon
    ></v-file-input>

    <!-- <v-col col="12" lg="3">
        <v-btn @click="onUpload()">upload</v-btn>
      </v-col> -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "FileUpload",
  props: {},
  data: () => ({
    message: "",
    file: "",
  }),
  methods: {
    onSelect(file) {
      // console.log("%c onSelect file", "color:Navy  ");
      // console.log(file);
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      //const file = this.$refs.file.files[0];
      this.file = file;
      //   if(!allowedTypes.includes(file.type)){
      //     this.message = "Filetype is wrong!!"
      //   }
      //   if(file.size>500000){
      //     this.message = 'Too large, max size allowed is 500kb'
      //   }
    },
    async onUpload(cus_id) {
      const formData = new FormData();

      let files = this.file;
          
      if (files) {

        for (var i = 0; i < files.length; i++) {
          let fileData = files[i];
          formData.set('cus_id', cus_id);
          formData.append("files", fileData);
        }
        formData.append("cus_id", cus_id);
        
        console.log("%c onUpload formData", "color:LimeGreen");
        console.log(formData);
        let finish = await this.$token_api
          .post("/upload-customer-file", formData)
          .catch((e) => {
            this.$swal(
              "เกิดข้อผิดพลาดในการอัพโหลด",
              "กรุณาลองใหม่อีกครั้ง",
              "error"
            );
          });

        return finish;
      } else {
        console.log("not file");
        return;
      }
    },
  },
};
</script>

